import PropTypes from 'prop-types';

export const CrossCircleIcon = (props) => {
  const { className = '', style = {} } = props;
  return (
    <svg
      className={'custom-icon ' + className}
      style={style}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 9.63917L13.5477 8.09148C14.2025 7.43669 15.2541 7.43669 15.9089 8.09148C16.5637 8.74628 16.5637 9.79791 15.9089 10.4527L14.3612 12.0004L15.9089 13.5481C16.5637 14.2029 16.5637 15.2545 15.9089 15.9093C15.2541 16.5641 14.2025 16.5641 13.5477 15.9093L12 14.3616L10.4523 15.9093C9.79754 16.5641 8.74591 16.5641 8.09112 15.9093C7.43633 15.2545 7.43633 14.2029 8.09112 13.5481L9.63881 12.0004L8.09112 10.4527C7.43633 9.79791 7.43633 8.74628 8.09112 8.09148C8.74591 7.43669 9.79754 7.43669 10.4523 8.09148L12 9.63917Z"
        fill="#F22C2C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 6.48809 6.48809 2 12 2C17.5119 2 22 6.48809 22 12C22 17.5119 17.5119 22 12 22C6.48809 22 2 17.5119 2 12ZM4.05952 12C4.05952 16.381 7.61905 19.9405 12 19.9405C16.3929 19.9405 19.9405 16.381 19.9405 12C19.9405 7.61905 16.3929 4.05952 12 4.05952C7.60714 4.05952 4.05952 7.61905 4.05952 12Z"
        fill="#F22C2C"
      />
    </svg>
  );
};

CrossCircleIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};
